export default "__VITE_ASSET__CLPic5ln__"